import { useParams } from 'react-router-dom'
import ElementList from '../ElementList/ElementList'
import useSurveyAnswer, { Status } from '../../../hooks/useSurveyAnswer/useSurveyAnswer'
import Success from '../ElementList/Success/Success'
import { useSelector } from 'react-redux'
import props from '../../../../redux/props'
import TimeLimitReached from '../TimeLimitReached/TimeLimitReached'

const Preview = () => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const { surveyUUID } = useParams()
  const { survey, surveyAnswer, updateElement, updateOrganizationUnitUUID, updateDayNumber, submit, status, timeLimitReached } = useSurveyAnswer(
    surveyUUID,
    true,
  )

  if (!surveyAnswer) return <></>
  if (timeLimitReached) return <TimeLimitReached survey={survey} />
  return (
    <div>
      {status === Status.PENDING && (
        <ElementList
          survey={survey}
          answer={surveyAnswer}
          updateElement={updateElement}
          updateOrganizationUnitUUID={updateOrganizationUnitUUID}
          updateDayNumber={updateDayNumber}
          submit={submit}
        />
      )}
      {status === Status.SUCCESS && <Success survey={survey} />}
      <div className="font-bold text-gray text-2xl fixed top-20 right-10">{t.survey.answer.previewMode.watermark}</div>
    </div>
  )
}

export default Preview
